import React from 'react'
import { Menu } from 'antd'
import { FiMenu, FiChevronRight, FiUsers, FiImage, FiLogOut, FiShield, FiActivity, FiDatabase } from "react-icons/fi";
import { FaChalkboardTeacher } from "react-icons/fa";
import { MdOutlineVideoCameraBack } from "react-icons/md";
import { useNavigate } from 'react-router-dom';
import { GoPackage } from "react-icons/go";
import { VscNotebook } from "react-icons/vsc";
import { useAuth } from '../../contexts/AuthContext';
import { PERMISSIONS } from '../../constants/permissions';

const MenuList = ({darkTheme}) => {
    const navigate = useNavigate();
    const { hasPermission } = useAuth();

    // Build menu items based on permissions
    const menuItems = [];

    // Users menu
    if (hasPermission(PERMISSIONS.USERS_VIEW)) {
      menuItems.push(
        <Menu.SubMenu key="users" className='text-right' icon={<FiUsers  style={{ fontSize: "18px" }} />} title="کاربران">
          <Menu.Item key="admins" className='font-custom text-right' onClick={() => navigate("/dashboard/users")}  >ادمین ها</Menu.Item>
          <Menu.Item key="customers"  className='font-custom text-right' onClick={() => navigate("/dashboard/students")} >دانشجویان</Menu.Item>
        </Menu.SubMenu>
      );
    }

    // Gallery (Contents.View)
    if (hasPermission(PERMISSIONS.CONTENTS_VIEW)) {
      menuItems.push(
        <Menu.Item key="gallery" className='text-right' onClick={() => navigate("/dashboard/gallery")} icon={<FiImage style={{ fontSize: "18px" }} />}>آرشیو</Menu.Item>
      );
    }

    // Courses menu
    if (hasPermission(PERMISSIONS.COURSES_VIEW)) {
      menuItems.push(
        <Menu.Item key="courses" className='text-right' onClick={() => navigate("/dashboard/courses")} icon={<FaChalkboardTeacher style={{ fontSize: "18px" }} />}>دوره ها</Menu.Item>
      );
    }

    // Packages menu
    if (hasPermission(PERMISSIONS.PACKAGES_VIEW)) {
      menuItems.push(
        <Menu.Item key="packages" className='text-right' onClick={() => navigate("/dashboard/packages")} icon={<GoPackage style={{ fontSize: "18px" }} />}>پکیج ها</Menu.Item>
      );
    }

    // Content Management submenu
    if (hasPermission(PERMISSIONS.CONTENTS_VIEW)) {
      menuItems.push(
        <Menu.SubMenu key="contents" className='text-right' icon={<MdOutlineVideoCameraBack  style={{ fontSize: "18px" }} />} title="مدیریت محتوا">
          <Menu.Item key="videos" className='text-right' onClick={() => navigate("/dashboard/Videos")} >لیست ویدئو ها</Menu.Item>
          <Menu.Item key="Pdfs" className='text-right' onClick={() => navigate("/dashboard/Pdfs")} >لیست پی‌دی‌اف ها</Menu.Item>
          <Menu.Item key="Voices" className='text-right' onClick={() => navigate("/dashboard/Voices")} >لیست محتوای صوتی</Menu.Item>
        </Menu.SubMenu>
      );
    }

    // Exams submenu
    if (hasPermission(PERMISSIONS.QUESTIONS_VIEW) || hasPermission(PERMISSIONS.EXAMS_VIEW) || hasPermission(PERMISSIONS.EXAMBANKS_VIEW)) {
      const examSubItems = [];
      
      if (hasPermission(PERMISSIONS.QUESTIONS_VIEW)) {
        examSubItems.push(
          <Menu.Item key="questions" className='text-right' onClick={() => navigate("/dashboard/questions")} >بانک سوالات</Menu.Item>
        );
      }
      
      if (hasPermission(PERMISSIONS.EXAMS_VIEW)) {
        examSubItems.push(
          <Menu.Item key="exam" className='text-right' onClick={() => navigate("/dashboard/exams")} >آزمون ها</Menu.Item>
        );
      }
      
      if (hasPermission(PERMISSIONS.EXAMBANKS_VIEW)) {
        examSubItems.push(
          <Menu.Item key="examBank" className='text-right' onClick={() => navigate("/dashboard/ExamBanks")} >بانک آزمون</Menu.Item>
        );
      }

      if (examSubItems.length > 0) {
        menuItems.push(
          <Menu.SubMenu key="exams" className='text-right' icon={<VscNotebook  style={{ fontSize: "18px" }} />} title="بخش آزمون">
            {examSubItems}
          </Menu.SubMenu>
        );
      }
    }

    // Roles menu
    if (hasPermission(PERMISSIONS.ROLES_VIEW)) {
      menuItems.push(
        <Menu.Item key="roles" className='text-right' onClick={() => navigate("/dashboard/roles")} icon={<FiShield style={{ fontSize: "18px" }} />}>مدیریت نقش‌ها</Menu.Item>
      );
    }

    // Activity Logs
    if (hasPermission(PERMISSIONS.LOGS_VIEW)) {
      menuItems.push(
        <Menu.Item key="logs" className='text-right' onClick={() => navigate("/dashboard/logs")} icon={<FiActivity style={{ fontSize: "18px" }} />}>گزارش فعالیت‌ها</Menu.Item>
      );
    }

    if (hasPermission(PERMISSIONS.BACKUPS_VIEW)) {
      menuItems.push(
        <Menu.Item key="backups" className='text-right' onClick={() => navigate("/dashboard/backups")} icon={<FiDatabase style={{ fontSize: "18px" }} />}>پشتیبان پایگاه داده</Menu.Item>
      );
    }

  return (
    <Menu theme={darkTheme ? 'dark':'light'} className="font-custom h-[88vh] text-l mt-[1rem] flex flex-col gap-[10px] relative " mode='inline'>
      {menuItems}
    </Menu>
  )
}

export default MenuList